import React, { useState } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Grid,
  Card,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const faqs = [
  {
    question: "What is WhatsApp Payments?",
    answer:
      "WhatsApp Payments allows users to send and receive money directly within WhatsApp using their linked bank accounts via the Unified Payments Interface (UPI).",
  },
  {
    question: "Is WhatsApp Payments secure?",
    answer:
      "Yes, WhatsApp Payments uses end-to-end encryption to protect all transactions.",
  },
  {
    question: "What payment methods are supported?",
    answer:
      "WhatsApp Payments supports major banks and payment gateways for ease of use.",
  },
  {
    question: "How do I track payments?",
    answer:
      "All transactions can be tracked directly within your WhatsApp Business dashboard or integrated CRM.",
  },
  {
    question: "In which countries is WhatsApp Payments available?",
    answer:
      "As of 2024, only businesses in Brazil, Indiaand Singapore can collect payments directly within WhatsApp using WhatsApp Payments.",
  },
  {
    question: "Is WhatsApp Payments available for businesses?",
    answer:
      "Currently, WhatsApp Payments is primarily available for personal use in select countries like India and Brazil. However, businesses can integrate payment links and QR codes or use the WhatsApp Business API to direct users to external payment gateways.",
  },
  {
    question: "How do I enable WhatsApp Payments?",
    answer:
      "Yes, WhatsApp Payments uses end-to-end encryption to protect all transactions.",
  },
  {
    question: "Is WhatsApp Payments secure?",
    answer:
      "Yes, WhatsApp Payments uses end-to-end encryption to protect all transactions.",
  },
];

const Faq = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleAccordionChange = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 10 },
          py: { xs: 4, sm: 6, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Typography
          variant="h2"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            mb: 4,
            fontSize: { xs: "2rem", md: "3rem" },
            color: "#000",
            // backgroundColor: '#f2faf6',
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Grid container spacing={4}>
          {faqs.map((faq, index) => (
            <Grid item key={index} xs={12} lg={6}>
              <Card
                sx={{
                  backgroundColor: "rgb(255,255,255)",
                  height: "100%",
                  p: 4,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "1.2rem", md: "1.5rem" },
                    mb: 2,
                  }}
                >
                  {faq.question}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "1.2rem",
                    color: "text.secondary",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Faq;
